import { useContext } from 'react';

import UsersFilter from '@atom/components/common/usersFilter/UsersFilter';
import WorkOrdersContext, {
  FilterSection,
  WorkOrdersInputActionTypes,
} from '@atom/components/workOrders/WorkOrdersContext';
import { Icon, IconButton } from '@atom/mui';
import { WorkOrdersConnectionInput } from '@atom/types/work';
import { toggleFromSet } from '@atom/utilities/setUtilities';

import WorkOrdersAssigneeFilter from './WorkOrdersAssigneeFilter';

import classes from './workOrdersFilters.module.css';

const styles = {
  icon: {
    marginRight: '1rem',
  },
};

const WorkOrdersFiltersTeamSection = () => {
  const {
    collapsedSections,
    setCollapsedSections,
    workOrdersInputCart,
    filtersDisabled,
    dispatch,
  } = useContext(WorkOrdersContext);

  const onToggle = (section: FilterSection) => {
    setCollapsedSections(toggleFromSet(collapsedSections, section));
  };

  const updateValue = (
    property: keyof WorkOrdersConnectionInput,
    value: string[],
  ) => {
    dispatch({
      type: WorkOrdersInputActionTypes.UPDATE_WORK_ORDERS_INPUT_PROPERTY,
      data: {
        property,
        value,
      },
    });
  };

  return (
    <div className={classes.filtersSection}>
      <div className={classes.filtersSectionHeader}>
        <div>
          <Icon style={styles.icon}>people</Icon>
          Team
        </div>
        <IconButton onClick={() => onToggle(FilterSection.TEAM)} edge="end">
          <Icon>
            {collapsedSections.has(FilterSection.TEAM)
              ? 'keyboard_arrow_down'
              : 'keyboard_arrow_up'}
          </Icon>
        </IconButton>
      </div>
      {!collapsedSections.has(FilterSection.TEAM) && (
        <div className={classes.filtersSectionContent}>
          <div className={classes.filterContainer}>
            <WorkOrdersAssigneeFilter />
          </div>
          <div className={classes.filterContainer}>
            <UsersFilter
              value={workOrdersInputCart?.completedByIds}
              updateValue={newValue => updateValue('completedByIds', newValue)}
              disabled={filtersDisabled}
              placeholder="Search for user"
              label="Completed By"
            />
          </div>
          <div className={classes.filterContainer}>
            <UsersFilter
              value={workOrdersInputCart?.createdByIds}
              updateValue={newValue => updateValue('createdByIds', newValue)}
              disabled={filtersDisabled}
              placeholder="Search for user"
              label="Created By"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkOrdersFiltersTeamSection;
